<div class="row landingpageservices-ServicesDiv landingpageservices-ServicesDiv-margin"
    [ngClass]="tilesLength===6? 'landingpageservices-container-height': 'landingpageservices-container-height1'">
    <div *ngIf="tiles" class="uhc-font landingpage-servicetiles-padding mb-3 p-3">
        <h3 class="ml-2">Our Services</h3>
        <div class="row m-0 landingpageservices-tilesDiv">
            <ng-container *ngFor="let tile of visibleTiles; let i = index">
                <div class="landingpageservices-tileDiv landingpageservices-tileDiv-height">
                    <img class="landingpageservices-tileImage landingpageservices-tileImage-height"
                        src="{{tile.icon}}"><br>
                    <span class="landingpageservices-tileHeader tile-hover-link"
                        (click)="navigate(tile)">{{tile.Tile}}</span> <br>
                    <div class="tooltipCard"
                        [ngClass]="getTooltipClass(i)"
                        [ngStyle]="getTooltipStyle()">
                        <div class="tooltipArrow"
                            [ngStyle]="getTooltipArrowStyle(i)">
                        </div>
                        <div class="landingpageservices-tooltip-content landingpageservices-tileDesc-font">
                            <p class="landingpageservices-tooltip-content landingpageservices-tileDesc-font"
                                [innerHTML]="tile.Description"></p>
                            <ng-container *ngIf="tile.CostData=='Yes'">
                                <span class="landingpageservices-nextRefreshData">Next Cost Data Refresh:
                                    {{tcmNextRefresh}}</span><br />
                                <span class="landingpageservices-nextRefreshData">Cost Data Available:
                                    {{tcmAvailableData}}</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>